import * as React from 'react';
import { createSlotFill } from '@workbench-stack/components';
import { STATUSBAR_ITEM_SLOT_PROVIDER } from '../constants';
import { Registry } from '@vscode-alt/monaco-editor/esm/vs/platform/registry/common/platform';
import { IStatusbarRegistry, IStatusbarItem, IEditorInput } from '@workbench-stack/core';
import { StatusbarExtensions } from '../constants';

export type IStatusbarItemComponentProps = { item: IStatusbarItem, input: IEditorInput, visibleItemId: string };

export type IStatusbarItemSlotProps = { item: IStatusbarItem, input: IEditorInput };

export const { Fill: ItemContributionFill, Slot: ItemSlot }  = createSlotFill<IStatusbarItemComponentProps>(STATUSBAR_ITEM_SLOT_PROVIDER);

export const StatusbarItem: React.FC<IStatusbarItemSlotProps> = (props) => {
    const registry = Registry.as<IStatusbarRegistry>(StatusbarExtensions.Statusbar);
    const typename = props.item ? props.item.__typename : null;
    const typeId = props.item ? props.item.typeId : undefined;
    const itemDescriptor = registry.getItem({ __typename: typename, typeId });

    return React.useMemo(() => {
        return (
            itemDescriptor ? <ItemSlot fillProps={{ ...props, visibleItemId: itemDescriptor.id }} /> : null
        );
    }, [props.item.id, props.input]);
};




